const resources = {
    scanRewardsCard: 'Scan Reward Cards in Store'
};

module.exports = function getResource(label) {
    return resources[label];
};
